import React, { useState, useEffect } from "react";

import Tooltip from "../../tooltip";
import api from "../../../services/api.js";

import IconWarning from "../../../assets/icons/icon-warning-red.png";
import Arrow from "../../../assets/icons/icon-arrow-left-gray.png";
import Location from "../../../assets/icons/icon-pin-red.png";

import * as S from "./styles";
import { theme } from "../../../styles/theme.js";
import { Auxiliar, TaglineP } from "../../../styles/stylesTypography.js";

const NewCardNotification = () => {
    const [alerts, setAlerts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hasError, setHasError] = useState(false); 

    useEffect(() => {
        const fetchAlerts = async () => {
            try {
                const response = await api.get("/clima/alertas-geral");
                
                if (response.data.code === 422) {
                    setHasError(true);
                } else {
                    setAlerts(response.data.data);
                    setHasError(false);
                }
            } catch (error) {
                setHasError(true);
            }
        };

        fetchAlerts();
    }, []);

    const totalAlerts = alerts.length;

    const nextAlert = () => {
        if (currentIndex < totalAlerts - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const prevAlert = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    if (hasError || totalAlerts === 0) {
        return null;
    }

    return (
        <S.Container>
             {currentIndex > 0 && (
                <S.PrevButton onClick={prevAlert}>
                    <img src={Arrow} alt="Voltar" style={{width: "16px", height: "auto"}} />
                </S.PrevButton>
            )}

            {totalAlerts > 0 && (
                <S.Wrapper>
                    {alerts.map((item, index) => (
                        index === currentIndex && (
                            <S.CardNotification key={index} onClick={() => window.location = `/fazendas/${item.farm_id}/${item.producer_id}`}>
                                <S.ImageAndNotification>
                                    <S.ContainerImage>
                                        <img src={IconWarning} alt="Alerta" />
                                    </S.ContainerImage>

                                    <S.Notification>
                                        <Auxiliar color={theme.colors.red.Vermelho_erro}>{item.alerta}</Auxiliar>

                                        <Tooltip content={item.farm} animation="fade" delay={[300, 100]} arrow={true} theme="light" placement="bottom">
                                            <span> 
                                                <img src={Location} alt="Ícone de marcação de mapa" style={{width: "16px", height: "auto"}} />

                                                <TaglineP color={theme.colors.red.Vermelho_erro} fontWeight={800} style={{ padding: '0 0.5rem'}}>{item.farm}</TaglineP>
                                            </span>
                                        </Tooltip>
                                    </S.Notification>
                                </S.ImageAndNotification>
                            </S.CardNotification>
                        )
                    ))}
                </S.Wrapper>
            )}

            {currentIndex < totalAlerts - 1 && (
                <S.NextButton onClick={nextAlert}>
                    <img src={Arrow} alt="Avançar" style={{width: "16px", height: "auto"}} />
                </S.NextButton>
            )}
        </S.Container>
    );
};

export default NewCardNotification;